import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ErrorComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute) { }
  errorType: string = 'internal';
  ngOnInit() {
  		this.activatedRoute.queryParams.subscribe(params => {
  			this.errorType = this.activatedRoute.snapshot.paramMap.get("type");  			
  		});
  }
}
